<div class="network-quality-indicator"
     [class.excellent]="quality === NetworkQuality.EXCELLENT"
     [class.good]="quality === NetworkQuality.GOOD"
     [class.fair]="quality === NetworkQuality.FAIR"
     [class.poor]="quality === NetworkQuality.POOR"
     [class.very-poor]="quality === NetworkQuality.VERY_POOR"
     [title]="tooltipText">

  <div class="signal-bars" [style.color]="qualityColor">
    <div class="bar bar-1" [class.active]="bars[0]"></div>
    <div class="bar bar-2" [class.active]="bars[1]"></div>
    <div class="bar bar-3" [class.active]="bars[2]"></div>
    <div class="bar bar-4" [class.active]="bars[3]"></div>
    <div class="bar bar-5" [class.active]="bars[4]"></div>
  </div>

  <span class="quality-text">{{ qualityLabel }}</span>

  <i *ngIf="trendIcon" [class]="'pi ' + trendIcon + ' trend-icon'" [class.improving]="trend === QualityTrend.IMPROVING" [class.degrading]="trend === QualityTrend.DEGRADING"></i>

  <!-- Location Tracking Icon -->
  <div class="location-divider"></div>
  <i class="pi pi-map-marker location-icon"
     [class.active]="locationActive"
     [class.clickable]="locationActive"
     [title]="locationTooltip"
     (click)="onLocationClick()"></i>
</div>
